export const TERMINATED = 'TERMINATED';
export const PERMANENT = 'PERMANENT';
